// WhatsApp deep-link helper for direct visitor → sales chat
const WA_NUMBER = "919113906644"; // digits only, no + no spaces

const fmtINR = (v) => {
  if (typeof v !== "number") return "";
  if (v >= 10000000) return `₹${(v / 10000000).toFixed(2)} Cr`;
  if (v >= 100000)   return `₹${(v / 100000).toFixed(1)} L`;
  return `₹${v}`;
};

/**
 * Build a wa.me link that opens WhatsApp with a pre-filled message about a parcel.
 * @param {object} parcel  — AcrePulse parcel doc.
 * @param {object} opts    — {mode: "single" | "compare"} for slightly different phrasing.
 */
export function parcelWhatsappUrl(parcel, opts = {}) {
  if (!parcel) return `https://wa.me/${WA_NUMBER}`;
  const name = parcel.title || "an AcrePulse parcel";
  const location = parcel.corridor_location || "Bangalore";
  const pricePerAcre = typeof parcel.price_per_acre === "number" ? fmtINR(parcel.price_per_acre) : null;
  const total = (typeof parcel.price_per_acre === "number" && typeof parcel.size_acres === "number")
    ? fmtINR(parcel.price_per_acre * parcel.size_acres) : null;

  const lines = [
    opts.mode === "compare"
      ? `Hi AcrePulse! I'm reviewing this parcel in my comparison and want more details:`
      : `Hi AcrePulse! I'm interested in this parcel:`,
    "",
    `• Parcel: ${name}`,
    `• Location: ${location}`,
  ];
  if (pricePerAcre) lines.push(`• Price: ${pricePerAcre}/acre${total ? ` (total ~${total})` : ""}`);
  if (parcel.id)    lines.push(`• Link: ${window.location.origin}/map?p=${parcel.id}`);
  lines.push("", "Please share the legal scorecard and next available site-visit slot.");
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

export const WHATSAPP_NUMBER = WA_NUMBER;
